<template>
<!--  登陆注册一摸一样-->
  <Login/>
</template>

<script>
import Login from '@/views/login';

export default {
  name: 'Register',
  components: {
    Login
  }
};
</script>

<style scoped lang="scss">

</style>
